<h1 mat-dialog-title>No roles assigned</h1>
<div>
    <mat-icon>back_hand</mat-icon>
    <p>
        You don't have permission to access this resource.
        <br />Please contact support
    </p>
</div>
